import * as React from 'react';

import { useServiceTypes, ServiceTypeOption } from '@app/hooks/Crematory/useServiceTypes';
import { ServiceType } from '@app/objects/Pet';

interface ServiceTypeViewProps {
	value: ServiceType;

	isSpecial?: boolean;
	rush?: boolean;
}

export const ServiceTypeView: React.FC<ServiceTypeViewProps> = (props: ServiceTypeViewProps) => {
	const types = useServiceTypes();
	const string = React.useMemo(() => {
		const type = types.find((item: ServiceTypeOption) => item.value === props.value);
		let label = type === undefined ? 'Unknown Service Type' : type.label;

		if (props.rush) {
			label += ' Rush';
		}

		if (props.isSpecial) {
			label += ' Special';
		}

		return label;
	}, [props.value, types, props.rush, props.isSpecial]);

	return <span>{string}</span>;
};
